import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import DefaultLoader from "components/common/DefaultLoader";
import Disabled from "components/common/Disabled";
import {
  usePolicyForms,
  useRetroactiveDateSupport,
} from "components/layers/retroactiveDateSupport";
import * as labels from "config.labels";
import React from "react";
import { connect } from "react-redux";
import * as actions from "store/actions/pricing/pricingActions";
import * as staticDataHooks from "store/hooks/staticDataHooks";
import * as pricingSelectors from "store/selectors/pricing/pricingSelectors";

export const PolicyFormComponent = (props) => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  const { policyForms, isLoading } = usePolicyForms();
  const { supports, layer } = useRetroactiveDateSupport();
  return (
    <Grid item xs={12}>
      <FormControl variant={"filled"} fullWidth>
        <Disabled ifReadOnly>
          <InputLabel className={"input-label"}>
            {translateLabel(labels.POLICY_FORM_LABEL, {
              default: "Policy Form",
            })}
          </InputLabel>
          <Select
            id={"policy-form-selector"}
            value={isLoading ? "LOADING" : props.policyForm}
            onChange={(event) => {
              const policyForm = event.target.value;
              props.setPolicyForm(policyForm);
              if (
                layer?.retroactiveDate != null &&
                !supports(layer?.policyType, policyForm)
              ) {
                props.clearRetroactiveDate(layer.id);
              }
            }}
            disabled={isLoading || props.disabled}
            fullWidth
          >
            {isLoading ? (
              <MenuItem key={"LOADING"} value={"LOADING"}>
                <DefaultLoader
                  size={16}
                  style={{
                    display: "block",
                    textAlign: "center",
                  }}
                />
              </MenuItem>
            ) : (
              <MenuItem key={`Policy_Form_NULL`} value={"NO_SELECTION"} />
            )}
            {policyForms.map((policyForm) => {
              return (
                <MenuItem
                  key={`Policy_Form_${policyForm.code}`}
                  value={policyForm.code}
                >
                  {policyForm.name}
                </MenuItem>
              );
            })}
          </Select>
        </Disabled>
      </FormControl>
    </Grid>
  );
};

const mapDispatchToProps = {
  setPolicyForm: actions.setActiveLayerPolicyForm,
  clearRetroactiveDate: (layerId) =>
    actions.updateLayer({ layerId, values: { retroactiveDate: null } }),
};

const mapStateToProps = (state) => {
  return {
    policyForm:
      pricingSelectors.getActiveLayer(state).policyForm || "NO_SELECTION",
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PolicyFormComponent);
